import React, { Fragment } from "react";
import ZoneForm from "./ZoneForm";

const ZoneAdd = () => {
    return (
        <Fragment>
            <ZoneForm />
        </Fragment>
    )
}
export default ZoneAdd;
